var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduce1Mobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1727_26994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9043 20.0039C8.9043 13.3765 14.2769 8.00391 20.9043 8.00391H36.9043C43.5317 8.00391 48.9043 13.3765 48.9043 20.0039V48.0039H20.9043C14.2769 48.0039 8.9043 42.6313 8.9043 36.0039V20.0039Z",
    fill: "#FFD35B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_26994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5294 27.5594H28.4583C29.5192 27.5594 30.5366 27.9809 31.2868 28.731C32.0369 29.4812 32.4583 30.4986 32.4583 31.5594H26.2352L26.2361 32.4483H33.3472V31.5594C33.3444 30.6136 33.0712 29.6883 32.5597 28.8928H35.125C35.9652 28.8925 36.7883 29.1305 37.4988 29.579C38.2093 30.0276 38.7781 30.6683 39.1392 31.427C37.037 34.2012 33.6334 36.0039 29.7917 36.0039C27.3374 36.0039 25.2583 35.4794 23.5694 34.5594V26.2892C24.6509 26.4441 25.6721 26.8824 26.5294 27.5594V27.5594ZM22.6806 34.2261C22.6806 34.4618 22.5869 34.6879 22.4202 34.8546C22.2535 35.0213 22.0274 35.115 21.7917 35.115H20.0139C19.7781 35.115 19.552 35.0213 19.3853 34.8546C19.2187 34.6879 19.125 34.4618 19.125 34.2261V26.2261C19.125 25.9904 19.2187 25.7643 19.3853 25.5976C19.552 25.4309 19.7781 25.3372 20.0139 25.3372H21.7917C22.0274 25.3372 22.2535 25.4309 22.4202 25.5976C22.5869 25.7643 22.6806 25.9904 22.6806 26.2261V34.2261ZM34.2361 21.7817C34.9434 21.7817 35.6216 22.0626 36.1217 22.5627C36.6218 23.0628 36.9028 23.7411 36.9028 24.4483C36.9028 25.1556 36.6218 25.8338 36.1217 26.3339C35.6216 26.834 34.9434 27.115 34.2361 27.115C33.5289 27.115 32.8506 26.834 32.3505 26.3339C31.8504 25.8338 31.5694 25.1556 31.5694 24.4483C31.5694 23.7411 31.8504 23.0628 32.3505 22.5627C32.8506 22.0626 33.5289 21.7817 34.2361 21.7817ZM28.0139 19.115C28.7211 19.115 29.3994 19.3959 29.8995 19.896C30.3996 20.3961 30.6806 21.0744 30.6806 21.7817C30.6806 22.4889 30.3996 23.1672 29.8995 23.6673C29.3994 24.1674 28.7211 24.4483 28.0139 24.4483C27.3066 24.4483 26.6284 24.1674 26.1283 23.6673C25.6282 23.1672 25.3472 22.4889 25.3472 21.7817C25.3472 21.0744 25.6282 20.3961 26.1283 19.896C26.6284 19.3959 27.3066 19.115 28.0139 19.115V19.115Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1727_26994",
    x: 0.904297,
    y: 0.00390625,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.78 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1727_26994"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1727_26994",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_26994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(18.2363 17.3372)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduce1Mobile);
export default __webpack_public_path__ + "static/media/introduce1-mobile.bff96c0ceb00c013a2d5b4ee35247b78.svg";
export { ForwardRef as ReactComponent };